//api： https://github.com/ali-sdk/ali-oss
import OSS from "ali-oss";
import router from "@/router";
import { uuid, getMediaInfo } from "@/utils/common";
import { Message } from "element-ui";
import { saveFileInfo } from "@/api/common.js";
const oss = {
  state: {
    ossConfig: {
      domain: "https://da-library.oss-cn-shenzhen.aliyuncs.com/",
      region: "oss-cn-shenzhen",
      accessKeyId: "LTAI4GJjTX55Xcy899psz3Lm",
      accessKeySecret: "AOOQdGBF40kFEFPm1KhRpQavDAEJ3b",
      bucket: "da-library",
    },
    queue: [],
    complete: true,
    path: "",
    isOriginalPath: false,
  },
  mutations: {
    RESET_QUEUE(state) {
      state.path = router.app._route;
      state.complete = false;
      state.queue = [];
      state.progress = 0;
    },
    SET_QUEUE(state, filelist) {
      state.queue = filelist.map((file) => {
        return {
          file: file,
          progress: 0,
          checkpoint: "",
          ossPath: "",
        };
      });
    },
    UPDATE_QUEUE_ITEM(state, item) {
      let i = item.index;
      delete item.index;
      state.queue[i] = item;
      if (item.checkpoint) {
        localStorage.setItem(item.file.name, JSON.stringify(item.checkpoint));
      } else {
        state.queue[i].url = state.ossConfig.domain + item.ossPath;
        localStorage.removeItem(item.file.name);
        state.complete = i == state.queue.length - 1;
        if (state.complete) {
          state.isOriginalPath = state.path == router.app._route;
        }
      }
    },
    SET_QUEUE_ITEM_FILEID(state, item) {
      state.queue[item.index].fileID = item.fileID;
    },
  },
  actions: {
    //oss切片后默认上传并行数是5 chrome中同一域名请求数上限是6
    //先按顺序处理上传队列，如果还要提速，后续可分bucket存储
    async Upload({ state, commit, dispatch }, { files, callback }) {
      if (!state.complete) {
        Message({
          type: "warning",
          message: "请等待文件上传完成！",
        });
        return;
      }
      commit("RESET_QUEUE");
      commit("SET_QUEUE", files);
      //官方推荐每次上传都重新构建 原因未知
      const client = new OSS(state.ossConfig);
      for (let i = 0; i < state.queue.length; i++) {
        let file = state.queue[i].file;
        //oss中有点乱 测试环境加个前缀 方便快速查找到测试文件
        let prefix = process.env.NODE_ENV == "development" ? "0/" : "";
        let filename = `${prefix}${uuid(32)}.${file.name.split(".").pop()}`;
        try {
          let { name } = await client.multipartUpload(filename, file.raw, {
            checkpoint: JSON.parse(localStorage.getItem(file.name)),
            progress: (p, cp) => {
              commit("UPDATE_QUEUE_ITEM", {
                file: file,
                progress: p,
                checkpoint: cp,
                index: i,
              });
            },
          });
          commit("UPDATE_QUEUE_ITEM", {
            file: file,
            progress: 1,
            ossPath: name,
            index: i,
          });
        } catch (err) {
          console.log(err);
          client.cancel();
          Message.error("上传失败，请重试！");
          
          //移除本地碎片信息
          localStorage.removeItem(file.name);
          //还原队列状态
          state.complete = true;
          state.queue = [];
          
          break;
        }
      }
      if (state.complete) {
        let res = await dispatch("SaveFiles");
        !res && callback.bind(null, state.queue)();
      }
    },
    async SaveFiles({ state, commit }) {
      for (let i = 0; i < state.queue.length; i++) {
        let item = state.queue[i];
        let fileInfo = await getMediaInfo(item.file.raw);
        let params = {
          contentType: fileInfo.contentType,
          duration: fileInfo.duration || 0,
          extension: fileInfo.file.name.split(".").pop(),
          fileName: fileInfo.file.name,
          fileType: fileInfo.type,
          fileUrl: item.url,
          height: fileInfo.height || 0,
          size: fileInfo.size / 1000,
          width: fileInfo.width || 0,
        };
        try {
          let res = await saveFileInfo(params);
          commit("SET_QUEUE_ITEM_FILEID", {
            index: i,
            fileID: res.data,
          });
        } catch (e) {
          Message.error(e.msg);
          console.log(e);
          return true;
        }
      }
    },
    Download({ state }, { name, url }) {
      //官方推荐每次上传都重新构建 原因未知
      const client = new OSS(state.ossConfig);
      let signatureUrl = client.signatureUrl(
        url.replace(state.ossConfig.domain, "").split("?")[0],
        {
          response: {
            "content-disposition": `attachment; filename=${encodeURIComponent(
              name
            )}`,
          },
        }
      );
      window.open(signatureUrl);
    },
  },
};
export default oss;
